import React from 'react';
import { Alert, AlertColor, Link, Stack } from '@mui/material';
import routes from 'constants/routes';
import { MODAL_RULES_AGENCY_ID } from 'features/authorization/merchantRules/services';
import { useCardDeskAccess, useCardDeskSessionAgencyId } from '../../hooks/useCardDesk';
import { MerchantReferenceSource } from '../../hooks/useMerchantReference';

interface Notice {
	severity: AlertColor;
	text: string;
}

const COULD_NOT_READ: Notice = {
	severity: 'warning',
	text: 'No se pudieron leer las reglas de la base: se muestra la tabla fija del Power.',
};

const NOTICES: Partial<Record<MerchantReferenceSource, Notice>> = {
	fixed: COULD_NOT_READ,
	// Un 403 (el usuario no puede leerlas): en la página, el mismo aviso de siempre.
	denied: COULD_NOT_READ,
	empty: {
		severity: 'warning',
		text: 'No hay reglas vigentes cargadas en Reglas de cruce: se muestra la tabla fija del Power.',
	},
	slow: {
		severity: 'info',
		text: 'Las reglas de la base están tardando: se muestra la tabla fija del Power hasta que lleguen.',
	},
};

/**
 * Arriba de "Códigos de comercio y cuotas": si no se ven las reglas de la base, por qué (con el módulo apagado, nada:
 * la tabla fija es lo de siempre); y, para admin y superadmin, el link para cambiarlas en "Reglas de cruce". El link,
 * solo con las de la base a la vista y con Uruguay arriba: con otro país, Reglas de cruce no se usa (ver `CardDeskScreen`).
 */
export function MerchantReferenceStatus({ source }: { source: MerchantReferenceSource }): JSX.Element | null {
	const { canEdit } = useCardDeskAccess();
	const agencyId = useCardDeskSessionAgencyId();
	const editable = canEdit && source === 'base' && agencyId === MODAL_RULES_AGENCY_ID;
	const notice = NOTICES[source];
	if (!notice && !editable) return null;
	return (
		<Stack spacing={1} alignItems="flex-start" sx={{ mb: 2 }}>
			{editable && (
				<Link href={`${routes.operations.cardDeskRules}?seccion=aerolineas`} variant="body2">
					Editar en Reglas de cruce
				</Link>
			)}
			{notice && (
				<Alert severity={notice.severity} sx={{ alignSelf: 'stretch' }}>
					{notice.text}
				</Alert>
			)}
		</Stack>
	);
}
